import { IconButton, Tooltip } from '@mui/material';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import { useBookmarks } from '../contexts/BookmarkContext';

interface BookmarkButtonProps {
  courseId: number;
  size?: 'small' | 'medium' | 'large';
}

export default function BookmarkButton({ courseId, size = 'small' }: BookmarkButtonProps) {
  const { isBookmarked, toggle } = useBookmarks();
  const saved = isBookmarked(courseId);

  return (
    <Tooltip title={saved ? 'Remove bookmark' : 'Bookmark this course'}>
      <IconButton
        size={size}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          toggle(courseId);
        }}
        sx={{ color: saved ? 'primary.main' : 'text.secondary' }}
        aria-label={saved ? 'Remove bookmark' : 'Bookmark course'}
      >
        {saved ? (
          <BookmarkIcon fontSize={size === 'small' ? 'small' : 'medium'} />
        ) : (
          <BookmarkBorderIcon fontSize={size === 'small' ? 'small' : 'medium'} />
        )}
      </IconButton>
    </Tooltip>
  );
}
